import { combineReducers } from 'redux';
const initialState = {
    loader : true,
    errors : undefined,
    errorMessage : undefined,
};
const uploadData = (state = initialState, action) => {

    //console.log(action.type);
    switch(action.type){
        case "UPLOAD_INIT":
            return {
                ...state,
                loader : true
            }
        case "UPLOAD_ERROR":
            return {
                ...state,
                loader : false,
                errors : (action.data.error === 'invalid') ?true :false,
                errorMessage : (action.data.error === 'invalid') ? "The file is not supported" : ""
            }

        default:
            return state;
    }
}

const upload = combineReducers({
    uploadData
})

export default upload;
export const getUploadData = state => state.upload.uploadData;


// WEBPACK FOOTER //
// ./src/reducers/upload.js